export default {
  path: 'dashboards-sources-update',
  component: () =>
    import('@/views/dashboard/dashboard-sources/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'dashboards-sources-update',
      component: () =>
        import('@/views/dashboard/dashboard-sources/Main.vue'),
    }
  ],
};
